import React, { useContext } from 'react';
import DynamicHeader from './DynamicHeader';
import { HeaderDynamicContext } from '../../../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import { LOYALTY_BRANDING_CONFIG } from '../../../../../../constants';

function DynamicHeaderVM() {
  const { customer, loyaltyRewards } = useContext(HeaderDynamicContext);
  const { isInsider, loggedOut } = LOYALTY_BRANDING_CONFIG.hoverableSlideOutModal;
  const {
    aListIconClassName,
    availableRewardsText,
    headerContainerClassName,
    meterColor,
  } = loggedOut;

  return (
    <DynamicHeader
      aListIconClassName={aListIconClassName}
      availableRewardsText={availableRewardsText}
      className={headerContainerClassName}
      customerData={customer}
      loyaltyRewards={loyaltyRewards}
      isInsider={isInsider}
      meterColor={meterColor}
    />
  );
}

export default DynamicHeaderVM;
